import styles from './css/healthmonitoringmaxvalues.module.css';

export default function HealthmonitoringMaxValues(props) {
    var gal = (props.value && props.value.max_gal_cmpxy != undefined) ? props.value.max_gal_cmpxy.toFixed(2) : "-";
    var cmx  =  (props.value && props.value.ild_cm_x != undefined) ? props.value.ild_cm_x.toFixed(2) : "-";
    var cmy  =  (props.value && props.value.ild_cm_y != undefined) ? props.value.ild_cm_y.toFixed(2) : "-";
    var radx =  (props.value && props.value.ild_rad_x != undefined) ? (1/props.value.ild_rad_x).toFixed(0) : "-";
    var rady =  (props.value && props.value.ild_rad_y != undefined) ? (1/props.value.ild_rad_y).toFixed(0) : "-";
    var frqx =  (props.value && props.value.frq_x != undefined) ? props.value.frq_x.toFixed(2) : "-";
    var frqy =  (props.value && props.value.frq_y != undefined) ? props.value.frq_y.toFixed(2) : "-";
    radx = (radx == Infinity) ? "∞" : radx;
    rady = (rady == Infinity) ? "∞" : rady;
    return (
        <div className={styles.container}>
            <div>加速度[gal]</div><div className={styles.item_right}>{gal}</div>
            <div className={styles.border}></div><div  className={styles.border}></div>
            <div>層間変位[cm]</div><div className={styles.item_right}>{cmx}/{cmy}</div>
            <div className={styles.border}></div><div  className={styles.border}></div>
            <div>層間変形角[1/rad]</div><div className={styles.item_right}>{radx}/{rady}</div>
            <div className={styles.border}></div><div  className={styles.border}></div>
            <div>卓越振動数[Hz]</div><div className={styles.item_right}>{frqx}/{frqy}</div>
        </div>
    )
}
